import React from 'react'
import { BlockLoader } from 'components/Loaders'

import style from '../styles/goods.module.scss'
const ProductSkeleton = () => {
  return (
    <div className={style.skeleton_products}>
    {
      Array(4).fill(0).map((_, index) => (
        <BlockLoader key={index} height={600} className={style.skeleton_products__item}/>
      ))
    }
  </div>
  )
}

export default ProductSkeleton